import React, { useState } from 'react'
import classNames from 'classnames'

import { Text } from 'marketing-site/src/library/elements/Text'
import { mq } from 'marketing-site/src/library/utils'
import { IHeaderNavigationSignInLink } from '..'

export const HeaderNavigationSignInLink = ({
  contentType = 'flex',
  url,
  title,
  isAnyComponentActive,
  setIsActive,
}: IHeaderNavigationSignInLink): React.ReactElement => {
  const [isLinkActive, setIsLinkActive] = useState<boolean>(false)
  const isAnotherElementActive = isAnyComponentActive && !isLinkActive

  const toggleActiveState = (isActive: boolean) => {
    setIsLinkActive(isActive)
    setIsActive && setIsActive(isActive)
  }

  const handleMouseOver = () => {
    toggleActiveState(true)
  }

  const handleMouseOut = (event: React.MouseEvent) => {
    if (event.target !== document.activeElement) {
      toggleActiveState(false)
    }
  }

  const handleBlur = (event: React.FocusEvent) => {
    if (!event.currentTarget.contains(event.relatedTarget as Node)) {
      toggleActiveState(false)
    }
  }

  const classes = classNames('header-navigation-mobile-item__header', {
    muted: isAnotherElementActive,
  })

  return (
    <>
      <a
        href={url}
        className={classes}
        role="menuitem"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onFocus={handleMouseOver}
        onBlur={handleBlur}
        data-testid="header-navigation-sign-in-link"
      >
        <div className="header-navigation-mobile-item__title">
          <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="heading-3">
            {title}
          </Text>
        </div>
      </a>

      <style jsx>{`
        .header-navigation-mobile-item__header {
          @include focusable($inlineOffset: 0, $blockOffset: 0);
          white-space: nowrap;

          display: grid;
          grid-column-gap: 1rem;
          grid-template-columns: 1fr auto;
          justify-content: space-between;
          align-items: center;
          padding: 0 1.25rem;
          text-decoration: none;
          cursor: pointer;
          user-select: none;

          &::after {
            display: block;
            grid-column: 1/-1;
            grid-row: 2;
            content: '';
            position: relative;
            width: 100%;
            height: 1px;
            transition: height 0.24s 0.4s;
          }
        }

        .header-navigation-mobile-item__title {
          display: inline-block;
          width: 100%;
          padding: 1.25rem 0;
          white-space: nowrap;

          &--anchor {
            text-decoration: none;
            color: ${contentType === 'flex' ? 'var(--slate)' : 'var(--mvp-slate)'};
          }
        }

        @media (${mq.tablet}) {
          .header-navigation-mobile-item__header {
            padding: 0 1.25rem;
          }
        }
      `}</style>
    </>
  )
}
